module.exports = __webpack_public_path__ + "static/media/toolbox-dimple.4911ad0e.svg";